<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="ebook-toc" id="_idParaDest-1"><span class="Bookman-Italic-in-Poem CharOverride-1"><a id="_idTextAnchor000"></a> </span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">books by amanda lovelace</span></p>
<p class="Poem-Centered"><span class="CharOverride-3">the</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Bookman-Italic-in-Poem CharOverride-4">women are some kind of magic</span></p>
<p class="Poem-Centered"><span class="CharOverride-3">series:</span></p>
<p class="Poem-Centered t"><span class="Bookman-Italic-in-Poem CharOverride-5">the princess saves herself in this one (#1)</span></p>
<p class="Poem-Centered"><span class="Bookman-Italic-in-Poem CharOverride-5">the witch doesn’t burn in this one (#2)</span></p>
<p class="Poem-Centered"><span class="CharOverride-5">the mermaid’s voice returns in this one (#3)</span></p>
<p class="Poem-Centered t"><span class="CharOverride-5">slay those dragons: a journal for writing  your own story</span></p>
<p class="Poem-Centered t"><span class="CharOverride-6">***</span></p>
<p class="Poem-Centered t"><span class="CharOverride-6">the</span></p>
<p class="Poem-Centered"><span class="CharOverride-6">things that h(a)unt</span></p>
<p class="Poem-Centered"><span class="CharOverride-6">duology:</span></p>
<p class="Poem-Centered t"><span class="Bookman-Italic-in-Poem CharOverride-5">to make monsters out of girls (#1)</span></p>
<p class="Poem-Centered"><span class="Bookman-Italic-in-Poem CharOverride-5">to drink coffee with a ghost (#2)</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer004">
<p class="ebook-toc" id="_idParaDest-2"><span class="Bookman-Italic-in-Poem CharOverride-1"><a id="_idTextAnchor001"></a> </span></p>
<p class="Normal ParaOverride-1 p2"><span class="CharOverride-8">this is dedicated</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">to the one </span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">who loves ketchup</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">as much as</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">i do.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Heliotype-headers" id="_idParaDest-3"><span class="CharOverride-9"><a id="_idTextAnchor002"></a>trigger warning</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">child abuse,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">eating disorders,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">sexual assault,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">self-harm,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">violence,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">cheating,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">death,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">gore,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">blood,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">trauma,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">grief,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">&amp; possibly</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">more.</span></p>
<p class="Normal ParaOverride-1 t"><span class="CharOverride-8">remember to practice</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">self-care before,</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">during, &amp; after</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-8">reading.</span></p>
</div>
<div class="Basic-Text-Frame" epub:type="toc" id="_idContainer006">
<p class="Heliotype-headers p2" id="_idParaDest-4"><span class="CharOverride-9"><a id="_idTextAnchor003"></a>co</span><span class="CharOverride-9">n</span><span class="CharOverride-9">t</span><span class="CharOverride-9">e</span><span class="CharOverride-9">n</span><span class="CharOverride-9">ts</span></p>
<p class="Poem-Justified ParaOverride-2"><a href="#/To_Drink_Coffee_ebook1#_idTextAnchor006"><span class="Hyperlink CharOverride-3">ghost-mother</span></a></p>
<p class="Poem-Justified ParaOverride-2 t"><a href="#/To_Drink_Coffee_ebook2#_idTextAnchor040"><span class="Hyperlink CharOverride-3">ghost-daughter</span></a></p>
<p class="Poem-Justified ParaOverride-2 t"><a href="#/To_Drink_Coffee_ebook3#_idTextAnchor071"><span class="Hyperlink CharOverride-3">sun-showers</span></a></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="Poem-Flush-Left"><span class="CharOverride-3">when she thinks</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">i have forgotten her,</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every phone</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">rings off the hook—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every television screen</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">turns to static—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every faucet</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">twists on &amp; off—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every clock</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">strikes three a.m.—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every book</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">flies off the shelves—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every cabinet</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">swings wide open—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every stool</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">turns upside down—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every door</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">locks &amp; unlocks itself—</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">every lightbulb</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">explodes into pieces.</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">i haven’t </span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">forgotten;</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">there are</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">just some things</span></p>
<p class="Poem-Flush-Left t"><span class="CharOverride-3">i choose</span></p>
<p class="Poem-Flush-Left"><span class="CharOverride-3">not to remember.</span></p>
<p class="JB-Attribute-Flush-Left"><span class="CharOverride-10"><a id="_idTextAnchor004"></a>- </span><span class="CharOverride-11">welcome home.</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer009">
<p class="Poem-Justified"><span class="CharOverride-3">whenever i think of you, i envision our little white kitchen table. inside the drywall, i  imagine years of collected stories &amp;   laughter burrowed like chestnuts from  stowaway squirrels. my secrets are hidden  among them, too—the ones you expertly  ignored so you could still look at me &amp; see  the perfect daughter who never existed. none of these memories would be  complete without our coffee. so i sit down  at our little white kitchen table. i pour not  one but two cups. i wait &amp; wait &amp; wait even  though i know you won’t show up to hear  what i have to say.</span></p>
<p class="JB-Attribute-Flush-Left"><span class="CharOverride-11"><a id="_idTextAnchor005"></a>- communication was never our strong suit.</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div class="_idGenObjectStyle-Disabled" id="_idContainer010">
<img alt="ouji board pointing to hello" class="_idGenObjectAttribute-1" src="image/ToDrinkCoffeeWithAGhost_edited_01.png"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// To_Drink_Coffee_ebook.vue?66785c61